import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatExpansionPanel } from '@angular/material/expansion';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { validarPermissao } from '../../utils/permissionScreen/permissionScreen';
import {
  IOpcaoAcao,
  IOpcaoTela,
} from '../../utils/permissionScreen/permissionScreen.types';
import { ModuloService } from 'src/app/services/ModuloService/modulo.service';
import { BRAND } from '../../constants/brand';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('delayedDisplay', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('50ms 230ms ease-in', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class MenuComponent implements OnInit {
  readonly brand = BRAND;
  @ViewChild(MatAccordion) accordion: MatAccordion | undefined;
  @ViewChildren(MatExpansionPanel)
  expansionPanels!: QueryList<MatExpansionPanel>;
  isMenuExpanded: boolean = false;
  isMobileMenuOpen: boolean = false;
  activeRoute: string = '';
  userOpenedPanel: string | null = null;
  panelSelectedState: { [key: string]: boolean } = {
    frotas: false,
    agendamento: false,
    parametrizacao: false,
    acessosInternos: false,
    edicaoEmpresa: false,
    gateEntrada: false,
    gateSaida: false,
    relatorios: false,
    empresa: false,
    caixa: false,
    estoque: false,
  };

  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private moduloService: ModuloService,
    private eRef: ElementRef
  ) {}

  ngOnInit() {
    this.setInitialActiveRoute();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.setInitialActiveRoute();
      });
  }

  setInitialActiveRoute() {
    this.activeRoute = this.router.url;
    this.updateSelection();
  }

  @HostListener('document:click', ['$event'])
  clickout(event: MouseEvent) {
    if (!this.isMenuExpanded) return;

    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeMenuByOutsideClick();
    }
  }

  closeMenuByOutsideClick() {
    const menuContainer = document.querySelector('.menu-container');

    menuContainer?.classList.remove('expanded');
    this.accordion?.closeAll();
    this.userOpenedPanel = null;
    this.toggleMobileMenu();
    this.isMenuExpanded = false;

    this.cd.detectChanges();
  }

  viewMenu(menu: IOpcaoTela, acao: IOpcaoAcao): boolean {
    return validarPermissao(menu, acao);
  }

  updateSelection() {
    const routes = [
      'frotas',
      'agendamento',
      'parametrizacao',
      'acessos-internos',
      'edicao-empresa',
      'gateEntrada',
      'gateSaida',
      'relatorios',
      'empresa',
      'caixa',
      'servicos',
      'laudosHigienizacao',
      'engate',
      'desengate',
      'logs',
      'paletes',
      'higienizacaoAgendada',
      'motoristasExterno',
      'estoque',
    ];
    routes.forEach((route) => {
      this.panelSelectedState[route] = false;
    });

    if (this.userOpenedPanel) {
      this.panelSelectedState[this.userOpenedPanel] = true;
    }

    this.cd.detectChanges();
  }

  expand(isValue: boolean = false) {
    const menuContainer = document.querySelector('.menu-container');

    if (isValue) {
      if (!menuContainer?.classList.contains('expanded')) {
        menuContainer?.classList.add('expanded');
        this.toggleMobileMenu();
        this.isMenuExpanded = true;
      } else {
        menuContainer?.classList.remove('expanded');
        this.accordion?.closeAll();
        this.userOpenedPanel = null;
        this.toggleMobileMenu();
        this.isMenuExpanded = false;
      }
    } else {
      if (!menuContainer?.classList.contains('expanded')) {
        menuContainer?.classList.add('expanded');
        this.toggleMobileMenu();
        this.isMenuExpanded = true;
      }
    }
  }

  openAccordeon(accordionId: string) {
    this.userOpenedPanel = accordionId;
    this.updateSelection();
  }

  closeAccordeon(accordionId: string) {
    if (this.userOpenedPanel === accordionId) {
      this.userOpenedPanel = null;
    }
    this.closeAllPanels();
    this.updateSelection();
  }

  closeAllPanels() {
    this.expansionPanels.forEach((panel) => panel.close());
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;

    if (!this.isMobileMenuOpen && this.accordion) {
      this.accordion.closeAll();
      this.userOpenedPanel = null;
    }
    if (!this.isMobileMenuOpen) {
      this.closeAllPanels();
    }
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  isModuloAtivo(modulo: string) {
    return this.moduloService.isModuloAtivo(modulo);
  }
}
